
import React from 'react';
import {
  User,
  Paperclip,
  Tag,
  Share2,
  Plus,
  Heart,
  MessageSquare,
  Pause } from
'lucide-react';

const menuItems = [
{ icon: User, label: 'Assigned To' },
{ icon: Paperclip, label: 'Attachments' },
{ icon: Tag, label: 'Tags' },
{ icon: Share2, label: 'Share' }];


export function Sidebar() {
  return (
    <aside className="sidebar">
      <div className="profile-placeholder">
        <Pause />
      </div>

      <nav className="sidebar-nav">
        {menuItems.map((item) =>
        <div key={item.label} className="sidebar-item">
            <div className="sidebar-item-content">
              <item.icon />
              <span>{item.label}</span>
            </div>
            <button className="sidebar-item-action">
              <Plus />
            </button>
          </div>
        )}
      </nav>

      <div className="sidebar-footer">
        <div className="sidebar-engagement">
          <button className="engagement-btn">
            <Heart />
            <span>0</span>
          </button>
          <button className="engagement-btn">
            <MessageSquare />
            <span>0</span>
          </button>
          <button className="follow-btn">FOLLOW</button>
        </div>

        <div className="sidebar-timestamps">
          <p>You last edited this · 15 hours ago</p>
          <p>You created this · 22 hours ago</p>
        </div>
      </div>
    </aside>);

}